import { memo, useCallback, useEffect, useRef, useState } from "react";
import {
    Grid,
    Typography,
    Box,
    Chip, Tabs, Tab
} from "@mui/material";
import { makeStyles } from '@mui/styles'
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useDispatch, useSelector } from "react-redux";

import { listReorder } from "../../utils/Reusables";
import ReportViewFilters from "./ReportViewFilters";

import { ReactComponent as XAxisIcon } from '../../assets/icons/icon-fieldwells-xaxis.svg';
import { ReactComponent as YAxisIcon } from '../../assets/icons/icon-fieldwells-yaxis.svg';
import ColumnIcon from '../../assets/icons/icon-fieldwells-column.png';
import { ReactComponent as GroupIcon } from '../../assets/icons/icon-fieldwells-group.svg';
import { ReactComponent as OrderByIcon } from '../../assets/icons/icon-fieldwells-orderby.svg';
import {ReactComponent as FieldWellsAddIcon } from '../../assets/icons/icon-fieldwells-add.svg';
import { ReactComponent as ChipCancelIcon } from '../../assets/icons/icon-fieldwells-chip-cancel.svg';
import { ReactComponent as DropdownIcon } from '../../assets/icons/icon-angle-down-white.svg';
import { reportActions } from "../../redux/reducers/report/reportReducer";
import CustomClickAwayPopup from "./Common/CustomClickAwayPopup";
import CustomFieldList from "./Common/CustomFieldList";

const useStyles = makeStyles(theme => ({

}))

const ReportFieldWells = ({ query, setQuery }) => {
    //console.log(query.order)
    const fieldWellsRef = useRef();
    const reportDetails = useSelector(state => state.reportDetails);
    //console.log(reportDetails)
    const dispatch = useDispatch();

    useEffect(() => {
        //console.log(reportDetails)
    }, [reportDetails?.fields])


    const onFieldsDragEnd = useCallback((result) => {
        //console.log(result)
        if (!result.destination) {
            return;
        }
        if (result.source.index === result.destination.index && result.destination.droppableId === result.source.droppableId) {
            return
        }        
        let fields = listReorder(JSON.parse(JSON.stringify(reportDetails.fields)), result.source.index, result.destination.index)
        //console.log(result.destination.droppableId)
        switch(result.destination.droppableId){
            case 'groups':
                fields[result.source.index].group = true
                console.log(fields[result.source.index])
                break;
            default:
                break;
        } 
        console.log(fields)   
        dispatch(reportActions.updateFieldList({list: fields}))
    })

    const onOrderDragEnd = useCallback((result) => {
        //console.log(result)
        if (!result.destination) {
            return;
        }
        if (result.source.index === result.destination.index) {
            return
        }
        const fields = listReorder(query.order, result.source.index, result.destination.index)
        //console.log(fields)
        setQuery({ ...query, order: [...fields] })
    })

    const handleDeleteField = useCallback((fieldObj, fieldIndex) => {
        let orderIndex = query.order ? query.order.map(obj =>  obj[0]).indexOf(fieldObj.member) : -1
        dispatch(reportActions.removeFieldByIndex({ fieldIndex}))
        query.order.splice(orderIndex, 1)
        if (fieldObj.fieldType == 'MEASURE') {
            query.measures = query.measures.filter(obj => obj != fieldObj.member)
        } else {
            query.dimensions = query.dimensions.filter(obj => obj != fieldObj.member)
        }
        setQuery({ ...query })
    })

    const onOrderBySelect = useCallback((field) => {
        let oldQuery = JSON.parse(JSON.stringify(query))
        let orderIndex  = oldQuery.order ? oldQuery.order.map(obj => obj[0]).indexOf(field.member):-1
        if( orderIndex > -1){
            oldQuery.order.splice(orderIndex, 1)
        }else{
            const orderField = field.member
            const order = field.fieldType == 'MEASURE' ? 'desc' : 'asc';
            oldQuery.order.push([orderField, order])
        }
        //console.log(oldQuery)
        setQuery({ ...oldQuery })
    })

    const handleOrderOption = useCallback((fieldObj, fieldIndex) => {
        console.log(fieldObj)
    })

    return <>
        <Grid container className="config_wrapper re-edit-fieldwells-wrapper" ref={fieldWellsRef} >
            <Grid item xs={9} >
                <Box className="fields-container" >
                    <DragDropContext onDragEnd={onFieldsDragEnd}>
                        {
                            ['table', 'number', 'gauge', 'funnel'].indexOf(reportDetails.chartType) > -1 &&
                            <Box className='re-fieldwells-axis-wrapper'>
                                <Droppable droppableId="fields" direction="horizontal">
                                    {(provided, snapshot) => (
                                        <div
                                            className="re-fieldwells-axis-container field-wells-elements"
                                            {...provided?.droppableProps}
                                            ref={provided?.innerRef}
                                        >
                                            <Box className='re-fieldwells-axis-title-wrapper'>
                                                <img src={ColumnIcon} className="re-fieldwells-axis-title-axis-firsticon" />
                                                <Box className='re-fieldwells-axis-title-axis-title'>Columns</Box>
                                                {/*<FieldWellsAddIcon className='re-fieldwells-axis-title-axis-lasticon' />*/}
                                            </Box>
                                            <Box className="re-fieldwells-axis-items" >
                                                <Tabs
                                                    variant="scrollable"
                                                    value={false}
                                                    scrollButtons="auto"
                                                    aria-label="scrollable auto tabs"
                                                >
                                                    {
                                                        reportDetails.fields && reportDetails.fields.length > 0 && reportDetails.fields.filter(obj => !obj.hidden).map((obj, index) => (
                                                            <Tab
                                                                key={`fields-${obj.name}`}
                                                                className={''}
                                                                label={
                                                                    <Draggable draggableId={obj.name} index={index}>
                                                                        {(provided, snapshot) => (
                                                                            <div
                                                                                ref={provided.innerRef}
                                                                                {...provided.draggableProps}
                                                                                {...provided.dragHandleProps}
                                                                            >
                                                                                <Chip deleteIcon={<ChipCancelIcon/>} label={obj.displayName} onDelete={e => handleDeleteField(obj, index)} />
                                                                            </div>
                                                                        )}
                                                                    </Draggable>
                                                                }
                                                            />
                                                        ))
                                                    }
                                                </Tabs>
                                                
                                            </Box>
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            </Box>
                        }
                        
                        {
                            ['table', 'number', 'gauge', 'funnel'].indexOf(reportDetails.chartType) < 0 &&
                            <>
                                <Box className='re-fieldwells-axis-wrapper'>
                                    <Droppable droppableId="x-axis" direction="horizontal">
                                        {(provided, snapshot) => (
                                            <div
                                                className="re-fieldwells-axis-container field-wells-elements"
                                                {...provided?.droppableProps}
                                                ref={provided?.innerRef}
                                            >
                                                <Box className='re-fieldwells-axis-title-wrapper'>
                                                    <XAxisIcon className="re-fieldwells-axis-title-axis-firsticon" />
                                                    <Box className='re-fieldwells-axis-title-axis-title'>X-Axis</Box>
                                                    {/*<FieldWellsAddIcon className='re-fieldwells-axis-title-axis-lasticon' />*/}
                                                </Box>
                                                <Box className="re-fieldwells-axis-items">
                                                <Tabs
                                                    variant="scrollable"
                                                    value={false}
                                                    scrollButtons="auto"
                                                    aria-label="scrollable auto tabs"
                                                >
                                                        {
                                                            reportDetails.fields && reportDetails.fields.length > 0 && reportDetails.fields.filter(obj => !obj.hidden && obj.axis === 'x').map((obj, index) => (
                                                                <Tab
                                                                    key={`x-axis-${obj.name}`}
                                                                    className={''}
                                                                    label={
                                                                        <Draggable  draggableId={obj.name} index={index}>
                                                                            {(provided, snapshot) => (
                                                                                <div
                                                                                    ref={provided.innerRef}
                                                                                    {...provided.draggableProps}
                                                                                    {...provided.dragHandleProps}
                                                                                >
                                                                                    <Chip deleteIcon={<ChipCancelIcon/>} label={obj.displayName} onDelete={e => handleDeleteField(obj, index)} />
                                                                                </div>
                                                                            )}
                                                                        </Draggable>
                                                                    }
                                                                />
                                                            ))
                                                        }
                                                    </Tabs>
                                                </Box>
                                            {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>
                                </Box>
                                <Box className='re-fieldwells-axis-wrapper'>
                                    <Droppable droppableId="y-axis" direction="horizontal">
                                        {(provided, snapshot) => (
                                            <div
                                                className="re-fieldwells-axis-container field-wells-elements"
                                                {...provided?.droppableProps}
                                                ref={provided?.innerRef}
                                            >
                                                <Box className='re-fieldwells-axis-title-wrapper'>
                                                    <YAxisIcon className="re-fieldwells-axis-title-axis-firsticon" />
                                                    <Box className='re-fieldwells-axis-title-axis-title'>Y-Axis</Box>
                                                    {/*<FieldWellsAddIcon className='re-fieldwells-axis-title-axis-lasticon' />*/}
                                                </Box>
                                                <Box className="re-fieldwells-axis-items">
                                                    <Tabs
                                                        variant="scrollable"
                                                        value={false}
                                                        scrollButtons="auto"
                                                        aria-label="scrollable auto tabs"
                                                    >
                                                        {
                                                            reportDetails.fields && reportDetails.fields.length > 0 && reportDetails.fields.filter(obj => !obj.hidden && obj.axis === 'y').map((obj, index) => (
                                                                <Tab
                                                                    key={`x-axis-${obj.name}`}
                                                                    className={''}
                                                                    label={
                                                                        <Draggable key={`y-axis-${obj.name}`} draggableId={obj.name} index={index}>
                                                                            {(provided, snapshot) => (
                                                                                <div
                                                                                    ref={provided.innerRef}
                                                                                    {...provided.draggableProps}
                                                                                    {...provided.dragHandleProps}
                                                                                >
                                                                                    <Chip deleteIcon={<ChipCancelIcon/>} label={obj.displayName} onDelete={e => handleDeleteField(obj, index)} />
                                                                                </div>
                                                                            )}
                                                                        </Draggable>
                                                                    }
                                                                />
                                                            ))
                                                        }
                                                    </Tabs>
                                                </Box>
                                            {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>
                                </Box>
                                <Box className='re-fieldwells-axis-wrapper'>
                                    <Droppable droppableId="lines" direction="horizontal">
                                        {(provided, snapshot) => (
                                            <div
                                                className="re-fieldwells-axis-container field-wells-elements"
                                                {...provided?.droppableProps}
                                                ref={provided?.innerRef}
                                            >
                                                <Box className='re-fieldwells-axis-title-wrapper'>
                                                    <YAxisIcon className="re-fieldwells-axis-title-axis-firsticon" />
                                                    <Box className='re-fieldwells-axis-title-axis-title'>Lines</Box>
                                                    {/*<FieldWellsAddIcon className='re-fieldwells-axis-title-axis-lasticon' />*/}
                                                </Box>
                                                <Box className="re-fieldwells-axis-items">
                                                    <Tabs
                                                        variant="scrollable"
                                                        value={false}
                                                        scrollButtons="auto"
                                                        aria-label="scrollable auto tabs"
                                                    >
                                                        {
                                                            reportDetails.fields && reportDetails.fields.length > 0 && reportDetails.fields.filter(obj => !obj.hidden && obj.axis === 'line').map((obj, index) => (
                                                                <Tab
                                                                    key={`lines-${obj.name}`}
                                                                    className={''}
                                                                    label={
                                                                        <Draggable  draggableId={obj.name} index={index}>
                                                                            {(provided, snapshot) => (
                                                                                <div
                                                                                    ref={provided.innerRef}
                                                                                    {...provided.draggableProps}
                                                                                    {...provided.dragHandleProps}
                                                                                >
                                                                                    <Chip deleteIcon={<ChipCancelIcon/>} label={obj.displayName} onDelete={e => handleDeleteField(obj, index)} />
                                                                                </div>
                                                                            )}
                                                                        </Draggable>
                                                                    }
                                                                />
                                                            ))
                                                        }
                                                    </Tabs>
                                                </Box>
                                            {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>
                                </Box>                                
                            </>
                        }
                        {   ['number', 'gauge', 'funnel'].indexOf(reportDetails.chartType) < 0 &&
                            <Box className='re-fieldwells-axis-wrapper'>
                            <Droppable droppableId="groups" direction="horizontal">
                                {(provided, snapshot) => (
                                    <div
                                        className="re-fieldwells-axis-container field-wells-elements fieldwells-group-item"
                                        {...provided?.droppableProps}
                                        ref={provided?.innerRef}
                                    >
                                        <Box className='re-fieldwells-axis-title-wrapper'>
                                            <GroupIcon className="re-fieldwells-axis-title-axis-firsticon" />
                                            <Box className='re-fieldwells-axis-title-axis-title'>Group</Box>
                                            {/*<FieldWellsAddIcon className='re-fieldwells-axis-title-axis-lasticon' />*/}
                                        </Box>
                                        <Box className="re-fieldwells-axis-items">
                                            <Tabs
                                                variant="scrollable"
                                                value={false}
                                                scrollButtons="auto"
                                                aria-label="scrollable auto tabs"
                                            >
                                                {
                                                    reportDetails.fields && reportDetails.fields.length > 0 && reportDetails.fields.filter(obj => !obj.hidden && obj.axis === 'group').map((obj, index) => (
                                                        <Tab
                                                            key={`groups-${obj.name}`}
                                                            className={''}
                                                            label={
                                                                <Draggable  draggableId={obj.name} index={index}>
                                                                    {(provided, snapshot) => (
                                                                        <div
                                                                            ref={provided.innerRef}
                                                                            {...provided.draggableProps}
                                                                            {...provided.dragHandleProps}
                                                                        >
                                                                            <Chip deleteIcon={<ChipCancelIcon/>} label={obj.displayName} onDelete={e => handleDeleteField(obj, index)} />
                                                                        </div>
                                                                    )}
                                                                </Draggable>
                                                            }
                                                        />
                                                    ))
                                                }
                                            </Tabs>
                                        </Box>
                                    {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </Box>
                        }
                    </DragDropContext>
                </Box>
            </Grid>

            <Grid item xs={3}>
                <Box className="orderby-container" >
                    <Box className="orderby-container-header">
                        <Box sx={{display: 'flex', justifyContent: 'flex-start'}}>
                            <OrderByIcon className="orderby-container-header-icon" />
                            <Box className="orderby-container-header-title">Order By</Box>
                        </Box>
                        {
                            reportDetails && reportDetails.fields && reportDetails.fields.length > 0 &&
                            <CustomClickAwayPopup icon={<FieldWellsAddIcon className='re-fieldwells-orderby-addicon' />} placement='bottom-end'>
                                <CustomFieldList 
                                    list={reportDetails.fields} 
                                    onSelectEvent={onOrderBySelect} 
                                    searchKey={'displayName'} 
                                    uniqueKey={'member'} 
                                    displayKey={'displayName'} 
                                    groupKey={'fieldType'} 
                                    selectedList={query.order && query.order.length > 0 ? query.order.map(obj => obj[0]):[]}
                                />
                            </CustomClickAwayPopup>
                        }
                        
                    </Box>
                    <Box className="orderby-container-items">
                        <DragDropContext onDragEnd={onOrderDragEnd}>
                            <Droppable droppableId="orderby" direction="vertical">
                                {(provided, snapshot) => (
                                    <div
                                        {...provided?.droppableProps}
                                        ref={provided?.innerRef}
                                        className="field-wells-order"
                                    >
                                        {
                                            query.order && query.order.map((obj, index) => (
                                                <Draggable key={`orderby-${obj[0]}`} draggableId={obj[0]} index={index}>
                                                    {(provided, snapshot) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                        >
                                                            <Chip
                                                                label={obj[0].split('.')[1]}
                                                                onDelete={e => handleOrderOption(obj, index)}
                                                                deleteIcon={<DropdownIcon />}
                                                            />
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))
                                        }
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </Box>
                </Box>
            </Grid>
                
        </Grid>    
    </> 
}

export default memo(ReportFieldWells)
